import type { SVGProps } from 'react'

interface SatelliteTechnologyIconProps extends SVGProps<SVGSVGElement> {}

export function SatelliteTechnologyIcon(props: SatelliteTechnologyIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 416.33 416.33"
      fill="currentColor"
      {...props}
    >
      <g id="Camada_3">
        <path
          className="st0"
          d="M201 233.33c7.87 15.9 6.29 35.02-5.01 48.82-3.7 4.52-7.5 7.63-13.44 4.12l-21.05-20.94c-1.84 1.53-3.49 3.9-5.34 5.32-8.14 6.25-17.5-3.37-11.15-11.48.71-.91 5.07-4.7 4.97-5.3l-20.45-20.58c-4.14-5.94-.93-9.97 3.8-13.81 13.76-11.19 32.8-12.89 48.67-5.16-1.08-4.89-1.52-10.06-.51-15.01.38-1.85 1.36-3.53 1.46-5.41l-11.83-11.88c-6.07 4.22-11.14 15.59-19.95 9.64L77 117.49c-6.17-10.08 5.25-13.32 12.21-16.79 15.83-7.89 33.45-17.28 49.56-24.11 4.82-2.04 8.23-2.58 11.84 1.95l42.45 74.55c2.79 7.76-6.77 12.18-10.71 17.44l10.31 10.64 36.12-35.16 40.72 40.64-35.5 35.83 12.16 12.16c5.47-4.17 10.04-14.3 18.17-10.83l73.78 42.22c3.18 2.29 4.49 6.42 2.84 10.07l-29.89 61.44c-2.35 3.56-6.59 4.77-10.48 3.01-25.54-24.36-50.11-49.91-75.25-74.75-6.73-8.76 5.18-13.81 9.34-19.99l-13.45-13.44c-6.52 2.67-13.49 3-20.23.94zM82.6 256.75c5.18-.45 8.33 3.67 8.73 8.42.3 3.56.13 6.53.78 10.22 4.41 25.32 26.14 45.79 51.73 48.6 5.32.58 11.97-.95 14.32 5.34 1.55 4.14-.28 8.63-4.4 10.25-4.35 1.71-15.61-.31-20.43-1.42-31.55-7.26-56.27-36.15-57.99-68.67-.3-5.68.15-12.12 7.26-12.74zM260.26 122.43c21-2.14 37.61 16.63 31.82 37.16-1.98 7.03-6.39 11.59-11.59 16.41l-40.81-40.87c5.01-6.4 12.22-11.84 20.57-12.69z"
        />
        <path
          className="st0"
          d="M116.26 256.74c2.74-.29 5.83 1.16 7.35 3.48 1.86 2.85 1.23 6.23 1.82 9.51 1.87 10.4 10.8 18.85 21.16 20.51 4.85.78 10.58-.13 11.93 6.41 1.56 7.58-4.67 10.09-11.03 9.7-16.75-1.03-31.81-13.51-36.57-29.43-1.94-6.5-4.6-19.14 5.35-20.18z"
        />
      </g>
    </svg>
  )
}
